import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';
import { RubberCollectionObject } from '../RubberCollectionSchema';
import { validateProperty, validate } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const screenCode = 'RUBBERCOLLECTIONREPORT';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function RubberCollectionReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState();
    const [errors, setErrors] = useState({});
    const [sessions, setSessions] = useState({});
    const schema = Joi.object(RubberCollectionObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [collectionCategoryReport, setcollectionCategoryReport] = useState([])

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            searchDate: ""
        }
    );
    const initialCsvHeaders = [
        { label: "Emp.No", value: "epfNo" },
        { label: "Emp.Type", value: "employeeTypeName" },
        { label: "Emp.Name", value: "employeeName" },
        { label: "Card Number", value: "cardNumber" },
        { label: "Card ReadTime", value: "cardReadTime" },
        { label: "Total Litres", value: "totalLitres" },
        { label: "Metrolac Value", value: "metrolacValue" },
        { label: "Dry Rubber Kilo", value: "dryRubberKilo" },
    ];

    const [isTableHide, setIsTableHide] = useState(true);
    const [deductionTypeNamesOfTable, setDeductionTypeNamesOfTable] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [totalValues, setTotalValues] = useState({
        totalTotalLitres: 0,
        totalMetrolacValue: 0,
        totalDryRubberKilo: 0
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        feild: "",
        session: "",
        date: ""
    })

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown(),
            getDeductionTypesForTable()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown(),
            getMobileSessions()
        )
    }, [searchForm.estateID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.divisionID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.searchDate]);

    useEffect(() => {
        trackPromise(
            getMobileSessions()
        )
    }, [searchForm.fieldID]);

    useEffect(() => {
        if (collectionCategoryReport.length != 0) {
            calculateTotalQty()
        }
    }, [collectionCategoryReport]);

    async function getMobileSessions() {
        if (searchForm.searchDate !== "")
            getMobileSessionsForDropDown();
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWRUBBERCOLLECTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function getDeductionTypesForTable() {
        const deductionTypeNames = await services.GetAllDedtuctionTypeNames();
        setDeductionTypeNamesOfTable(deductionTypeNames);
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(searchForm);
        setFields(fields);
    }

    async function getMobileSessionsForDropDown() {
        const selectedSessions = await services.GetMobileSessionsForWeighReport(searchForm);
        setSessions(selectedSessions);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    // function handleChange(e) {
    //     const target = e.target
    //     const value = target.name === 'active' ? target.checked : target.value

    //     const error = { ...errors }
    //     const errorMessage = validateProperty(target, RubberCollectionObject)
    //     errorMessage ? error[target.name] = errorMessage : delete error[target.name]

    //     setSearchForm({
    //         ...searchForm,
    //         [e.target.name]: value
    //     });
    //     setErrors(error);
    // }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: "0",
            sessionID: "0",
            searchDate: target.value
        });
    }

    function handleFieldChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: target.value,
            sessionID: "0"
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, RubberCollectionObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchForm);
        var reportData = await services.GetWeighReportData(searchForm);

        setcollectionCategoryReport(reportData);
    }

    function calculateTotalQty() {
        const totalTotalLitres = collectionCategoryReport.reduce((accumulator, current) => accumulator + current.totalLitres, 0);
        const totalMetrolacValue = collectionCategoryReport.reduce((accumulator, current) => accumulator + current.metrolacValue, 0);
        const totalDryRubberKilo = collectionCategoryReport.reduce((accumulator, current) => accumulator + current.dryRubberKilo, 0);
        setTotalValues({
            ...totalValues,
            totalTotalLitres: totalTotalLitres,
            totalMetrolacValue: totalMetrolacValue,
            totalDryRubberKilo: totalDryRubberKilo,
        })
    };

    function createFile() {
        collectionCategoryReport.forEach(element => {
            element.cardReadTime = moment(element.cardReadTime).format("HH:mm:ss");
            element.totalLitres = element.totalLitres.toFixed(2);
            element.metrolacValue = element.metrolacValue.toFixed(2);
            element.dryRubberKilo = element.dryRubberKilo.toFixed(2);
        });
        var settings = {
            sheetName: 'Rubber Col Report',
            fileName:
                'Rubber Collection Report - ' +
                selectedSearchValues.date,
            writeOptions: {}
        };
        var copyOfCsv = _.cloneDeep(collectionCategoryReport)
        var vr = {
            epfNo: 'Total',
            totalLitres: totalValues.totalTotalLitres.toFixed(2),
            metrolacValue: totalValues.totalMetrolacValue.toFixed(2),
            dryRubberKilo: totalValues.totalDryRubberKilo.toFixed(2)
        }
        var newRow1 = {
            epfNo: 'Group: ' + selectedSearchValues.group,
            employeeTypeName: 'Estate: ' + selectedSearchValues.estate,
            employeeName: selectedSearchValues.division === undefined ? 'Division: All Divisions ' : 'Division: ' + selectedSearchValues.division,
            cardNumber: 'Date: ' + selectedSearchValues.date,
            cardReadTime: selectedSearchValues.feild === undefined ? 'Field : All Fields' : 'Field: ' + selectedSearchValues.feild
        }
        copyOfCsv.push(vr, {}, {}, newRow1)
        xlsx(initialCsvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            feild: fields[searchForm.fieldID],
            date: searchForm.searchDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef} className="card">
                        <PageHeader
                            title="Rubber Collection Report"
                        />
                        <div className="card-body">

                            <div className="row">
                                <div className="col">
                                    <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="groupID">Group *</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="groupID"
                                                    disabled={!permissionList.isGroupFilterEnabled}
                                                    name="groupID"
                                                    value={searchForm.groupID}
                                                    onChange={(e) => handleGroupChange(e.target)}>
                                                    <MenuItem value="0">--Select Group--</MenuItem>
                                                    {generateDropDownMenu(groups)}
                                                </Select>
                                                {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="estateID">Estate</InputLabel>
                                                <Select fullWidth
                                                    id="estateID"
                                                    name="estateID"
                                                    disabled={!permissionList.isOperationEntityFilterEnabled}
                                                    value={searchForm.estateID}
                                                    onChange={(e) => handleEstateChange(e.target)}>
                                                    <MenuItem value="0">--Select Estate--</MenuItem>
                                                    {generateDropDownMenu(estates)}
                                                </Select>
                                                {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="divisionID">Division *</InputLabel>
                                                <Select fullWidth
                                                    id="divisionID"
                                                    name="divisionID"
                                                    value={searchForm.divisionID}
                                                    onChange={(e) => handleDivisionChange(e.target)}>
                                                    <MenuItem value="0">--All Division--</MenuItem>
                                                    {generateDropDownMenu(divisions)}
                                                </Select>
                                                {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="searchDate">Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="searchDate"
                                                    name="searchDate"
                                                    type="date"
                                                    onChange={(e) => handleDateChange(e.target)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="fieldID">Field</InputLabel>
                                                <Select fullWidth
                                                    id="fieldID"
                                                    name="fieldID"
                                                    value={searchForm.fieldID}
                                                    onChange={(e) => handleFieldChange(e.target)}>
                                                    <MenuItem value="0">--All Field--</MenuItem>
                                                    {generateDropDownMenu(fields)}
                                                </Select>
                                                {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                            </div>
                                            {/* <div className="col-md pb-1">
                                                <InputLabel shrink id="fieldID">Session</InputLabel>
                                                <Select fullWidth
                                                    id="sessionID"
                                                    name="sessionID"
                                                    value={searchForm.sessionID}
                                                    onChange={(e) => handleChange(e)}>
                                                    <MenuItem value="0">--All Session--</MenuItem>
                                                    {generateDropDownMenu(sessions)}
                                                </Select>
                                                {errors["sessionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["sessionID"]}</FormHelperText>}
                                            </div> */}
                                        </div>

                                        <input
                                            type="submit"
                                            disabled={validate(schema, searchForm)}
                                            className="btn btn-primary"
                                            value="Generate"
                                        />
                                    </form>
                                </div>
                                <div class="w-100"></div>
                                <div className="col pl-5"
                                    style={{ maxWidth: "1460" }}
                                >
                                    {collectionCategoryReport.length > 0 ?
                                        <div>
                                            <div className="table-responsive row-top-gap" >
                                                <div>
                                                    <TableContainer component={Paper}>
                                                        <Table className={classes.table} aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Emp.No</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Emp.Type</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Emp.Name</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Card Number</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Card ReadTime</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Total Litres</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Metrolac Value</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Dry Rubber Kilo</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {collectionCategoryReport.slice(page * limit, page * limit + limit).map((row, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell component="th" scope="row" align="left"> {row.epfNo}</TableCell>
                                                                        <TableCell component="th" scope="row" align="left"> {row.employeeTypeName}</TableCell>
                                                                        <TableCell component="th" scope="row" align="left"> {row.employeeName}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {row.cardNumber}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {moment(row.cardReadTime).format("HH:mm:ss")}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {row.totalLitres.toFixed(2)}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {row.metrolacValue.toFixed(2)}</TableCell>
                                                                        <TableCell component="th" scope="row" align="right"> {row.dryRubberKilo.toFixed(2)}</TableCell>
                                                                    </TableRow>
                                                                )
                                                                )}
                                                            </TableBody>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                                                        <b>{totalValues.totalTotalLitres.toFixed(2)}</b></TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                                                        <b>{totalValues.totalMetrolacValue.toFixed(2)}</b></TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                                                                        <b>{totalValues.totalDryRubberKilo.toFixed(2)}</b></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                        </Table>
                                                        <TablePagination
                                                            component="div"
                                                            count={collectionCategoryReport.length}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleLimitChange}
                                                            page={page}
                                                            rowsPerPage={limit}
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                        />
                                                    </TableContainer>
                                                </div>
                                            </div>
                                            {collectionCategoryReport.length > 0 ?
                                                <div className="pt-2">
                                                    <ReactToPrint
                                                        documentTitle={"Check Roll Weighment Report"}
                                                        trigger={() => <input
                                                            type="button"
                                                            className="btn btn-primary pull-right ml-2"
                                                            value="Create PDF"
                                                        />}
                                                        content={() => componentRef.current}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePdf ref={componentRef} collectionCategoryReport={collectionCategoryReport} totalValues={totalValues}
                                                            searchData={selectedSearchValues} />
                                                    </div>
                                                    <input
                                                        type="button"
                                                        className="btn btn-primary pull-right ml-2"
                                                        value="Excel"
                                                        onClick={createFile}
                                                    />
                                                </div> : null}
                                        </div>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

